var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatterySelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.409,
    height: 41.932,
    viewBox: "0 0 39.409 41.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "battery",
    d: "M63.633,11H56.025a1.522,1.522,0,0,0-1.518,1.518v7.608a1.522,1.522,0,0,0,1.518,1.518h3.161V33.336a.968.968,0,0,1-.965.965H56.466v-.63A1.165,1.165,0,0,0,55.3,32.51H54.23v4.869H55.3a1.165,1.165,0,0,0,1.161-1.161v-.63H58.22a2.255,2.255,0,0,0,2.252-2.252V21.643h3.161a1.522,1.522,0,0,0,1.518-1.518V12.518A1.522,1.522,0,0,0,63.633,11Zm-3.8,8.89A3.568,3.568,0,1,1,63.4,16.322,3.575,3.575,0,0,1,59.829,19.89ZM25.782,46.552h27.14V49.2H25.782Zm3.678,3.915h3.559v2.466H29.46Zm16.226,0h3.559v2.466H45.686Zm-5.9-27.154a8.491,8.491,0,0,0,1.183-2.191h3.745l.664,2.191H39.782Zm-6.819,2.131a7.222,7.222,0,1,0-7.222-7.222,7.236,7.236,0,0,0,7.222,7.222Zm-.736-12.518h3.1l-1.859,3.219H36.96l-6.679,7.374,1.765-4.967H28.968l3.26-5.626ZM52.882,27a2.406,2.406,0,0,0-2.4-2.4H38.6a8.507,8.507,0,0,1-11.146.1A2.408,2.408,0,0,0,25.742,27V45.29h27.14ZM30.674,29.26H47.951v4.313H30.674V29.26Zm3.81,11.754h-3.81V37.2h3.81Zm6.508,0h-3.81V37.2h3.81Zm6.79.056a2.774,2.774,0,1,1,.813-1.962A2.766,2.766,0,0,1,47.781,41.07Zm-.91-3.014a1.486,1.486,0,0,1-1.544,2.454l.947-.947a.643.643,0,0,0-.91-.91l-.947.947a1.487,1.487,0,0,1,2.454-1.544ZM59.211,16.322a.765.765,0,1,1-.765-.765A.767.767,0,0,1,59.211,16.322Zm2.766,0a.765.765,0,1,1-.765-.765A.767.767,0,0,1,61.977,16.322Z",
    transform: "translate(-25.742 -11)",
    fill: "#df9426",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatterySelectedIcon);
export default __webpack_public_path__ + "static/media/battery_selected_icon.67aee1c488418f679e02746c3ab9a2b9.svg";
export { ForwardRef as ReactComponent };